<i18n>
en:
  complete:
    msg: "Please check the email sent to the specified E-mail."
  mail:
    label: "E-mail"
  submit: "Send"
  error:
    IUM001: "This E-mail is already registered."
ja:
  complete:
    msg: "指定のメールアドレスにメールを送りましたので確認してください。"
  mail:
    label: "メールアドレス"
  submit: "送信する"
  error:
    IUM001: "このメールアドレスは使用されているため登録できません。"
</i18n>

<template lang="pug">
  div.my-6
    v-container
      //- 正常終了
      template(v-if="isComplete")
        v-row
          v-col.mb-12.pb-12(cols="12" align="center")
            v-alert(dense outlined prominent type="success" border="bottom")
              div(v-html="$t('complete.msg')")

      //- 入力フォーム
      template(v-else)
        v-form(onsubmit="return false" v-model="valid")
          v-row(justify="center")
            v-col(cols="12" sm="6" md="4" xl="2")
              v-text-field(prepend-icon="fa-envelope" :label="$t('mail.label')" :rules="v($t('mail.label'), ['required', 'mail'])" v-model="forms.mailAddress")

          //- 送信ボタン
          v-row(justify="center")
            v-col(cols="12" sm="6" md="4" xl="2")
              v-btn(x-large block color="primary" type="submit" @click="submit" :loading="isSubmit" :disabled="!valid")|{{$t('submit')}}

          //- エラーメッセージ
          v-row(v-if="errMsg")
            v-col(cols="12" align="center")
              v-alert.d-inline-block(dense outlined type="error")
                div(v-html="errMsg")
</template>

<script>
export default {
  data () {
    return {
      // 入力フォーム
      forms: {
        mailAddress: null
      },
      // 入力バリデーション
      valid: false,
      // 送信中
      isSubmit: false,
      // 完了
      isComplete: false,
      // エラーメッセージ
      errMsg: null
    }
  },
  methods: {
    /**
     * 送信
     */
    async submit () {
      if (this.isSubmit) {
        return
      }

      this.isSubmit = true
      this.isComplete = false
      this.errMsg = null

      // ユーザー種別
      let userKind
      if (this.$route.params.kind === null) {
        userKind = 0
      } else {
        userKind = this.utils.cast.int(this.$route.params.kind)
      }

      // 申込
      this.api.userEntry({
        userKind: userKind,
        mailAddress: this.forms.mailAddress
      })
        .then(response => {
          this.isComplete = true
        })
        .catch(response => {
          this.errMsg = this.$t(`error.${response.functionError.errorCode}`)
        })
        .finally(() => {
          this.isSubmit = false
        })
    }
  }
}
</script>

<style lang="sass" scoped>
</style>
